import appConfigInstance from '@tencent/docs-config';
import { snakeCaseKeys } from '@tencent/docs-scenario-component-tools';
import { pick } from 'lodash-es';
import { tencentDocOpenUrlForAll } from '@tencent/tencent_doc_open_url';
import { toURLSearchParams } from "../../utils/object-util";
export var openInNewWindow = function openInNewWindow(pageAction, options) {
  var urlOptions = pick(options, ['mobileMode', 'type', 'id', 'entry', 'padType', 'mimeType']);
  var queryString = toURLSearchParams(snakeCaseKeys(urlOptions)).toString();
  var link = appConfigInstance.getInstance().getConfig('links.docsComponentMiddleware');
  var url = "".concat(link, "?page-action=").concat(pageAction, "&").concat(queryString);
  tencentDocOpenUrlForAll({
    url: url,
    appOption: {
      showTitle: false
    }
  });
};